module.exports = __webpack_public_path__ + "static/media/9.91965666.jpg";